import { KpiCardComponent } from './kpi-card.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxCircularGaugeModule, DxChartModule, DxNumberBoxModule, DxTextBoxModule, DxTooltipModule, DxDataGridModule, DxButtonModule } from 'devextreme-angular';
import { DxoValueAxisModule, DxiValueAxisModule, DxiViewModule } from 'devextreme-angular/ui/nested';

@NgModule({
	declarations: [KpiCardComponent],
	exports: [KpiCardComponent],
  imports: [
		CommonModule,
		DxCircularGaugeModule,
		DxChartModule,
		DxNumberBoxModule,
		DxTextBoxModule,
		DxTooltipModule,
		DxDataGridModule,
		DxButtonModule,
		DxoValueAxisModule,DxiValueAxisModule,DxiViewModule
  ]
})
export class KpiCardModule { }
